import { render, staticRenderFns } from "./noticeDialog.vue?vue&type=template&id=7fa86ffc&scoped=true"
import script from "./noticeDialog.vue?vue&type=script&lang=js"
export * from "./noticeDialog.vue?vue&type=script&lang=js"
import style0 from "./noticeDialog.vue?vue&type=style&index=0&id=7fa86ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa86ffc",
  null
  
)

export default component.exports